"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e={SHORT:"HH:mm",LONG:"HH:mm:ss"};exports.TIME_FORMATS=e;
